import React, { useContext, useEffect, useState } from "react";
import styles from "./Boxes.module.css";

import DataTable from "react-data-table-component";
import { toast } from "react-toastify";

import AuthContext from "../../store/AuthCtx";
import { api } from "../../api/api";

import Modal from "../../components/dashboard/boxes/BoxModal";
import DeleteConfirmationModal from "../../components/dashboard/boxes/DeleteModal";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt, faEdit } from "@fortawesome/free-solid-svg-icons";

const buttonStyle = (color) => {
  return {
    background: color,
    outline: "none",
    border: "none",
    padding: "5px",
    borderRadius: "5px",
    color: "white",
    cursor: "pointer",
    fontWeight: "600",
    marginRight: "5px",
    fontSize: "16px",
  };
};

const customStyles = {
  headRow: {
    style: {
      border: "none",
    },
  },
  headCells: {
    style: {
      color: "white",
      backgroundColor: "#6f9be2",
      fontWeight: 600,
      fontSize: "16px",
    },
  },
  rows: {
    style: {
      borderBottomColor: "#FFFFFF",
    },
    highlightOnHoverStyle: {
      backgroundColor: "#bfcfea",
      borderBottomColor: "#FFFFFF",
    },
  },
};

function Boxes() {
  const [openModal, setOpenModal] = useState(false);
  const [boxes, setBoxes] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [changed, setChanged] = useState(false);
  const [selectedBox, setSelectedBox] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  //Table Config
  const columns = [
    {
      name: "Box Name",
      selector: (row) => row.name,
      width: "300px",
      style: {
        color: "#202124",
        fontSize: "14px",
        fontWeight: 500,
      },
    },
    {
      name: "Length",
      selector: (row) => row.length,
    },
    {
      name: "Width",
      selector: (row) => row.width,
    },
    {
      name: "Height",
      selector: (row) => row.height,
    },
    {
      name: "Weight",
      selector: (row) => row.weight,
    },
    {
      name: "Units",
      selector: (row) => row.unit,
    },
    {
      name: "Weight Unit",
      selector: (row) => row.weightUnit,
    },
    {
      name: "Position",
      selector: (row) => row.position,
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => row.status,
    },
    {
      cell: (row) => (
        <button
          onClick={() => editClickHandler(row._id)}
          style={buttonStyle("#6f9be2")}
        >
          <FontAwesomeIcon icon={faEdit} />
        </button>
      ),
      allowOverflow: true,
      button: true,
      width: "34px",
    },
    {
      cell: (row) => (
        <button
          onClick={() => {
            setSelectedBox(row._id);
            setDeleteModal(true);
          }}
          style={buttonStyle("red")}
        >
          <FontAwesomeIcon icon={faTrashAlt} />
        </button>
      ),
      allowOverflow: true,
      button: true,
      width: "34px",
    },
  ];

  const AuthCtx = useContext(AuthContext);

  useEffect(() => {
    if (AuthCtx.userToken) {
      const getBoxes = async () => {
        try {
          const data = await api.get("/boxes/getBoxes");
          setBoxes(data.data.boxes);
        } catch (err) {
          // toast.error("Error Occured");
        }
      };
      getBoxes();
    }
  }, [AuthCtx.isLoggedIn, changed, AuthCtx.userToken]);

  const addNewHandler = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const name = e.target.boxName.value;
    const length = e.target.length.value;
    const width = e.target.width.value;
    const height = e.target.height.value;
    const units = e.target.units.value;
    const weightUnit = e.target.weightUnit.value;
    const position = e.target.position.value;
    const status = e.target.status.value;
    const weight = e.target.weight.value;
    if (isEditing) {
      try {
        await api.put("/boxes/updateBox", {
          id: selectedBox,
          name: name,
          len: length,
          wid: width,
          hei: height,
          unit: units,
          wUnit: weightUnit,
          weight: weight,
          position,
          status,
        });
        e.target.reset();
        setOpenModal(false);
        setIsEditing(false);
        setSelectedBox(null);
        setIsLoading(false);
        toast.success("Update Successfully");
        setChanged((prev) => !prev);
      } catch (err) {
        toast.error("Something Went Wrong");
      }
    } else {
      try {
        await api.post("/boxes/createBox", {
          name: name,
          len: length,
          wid: width,
          hei: height,
          unit: units,
          wUnit: weightUnit,
          weight: weight,
          position,
          status,
        });
        e.target.reset();
        setOpenModal(false);
        toast.success("Added Successfully");
        setChanged((prev) => !prev);
      } catch (err) {
        toast.error("Something Went Wrong");
      }
    }
  };

  const deleteHandler = async () => {
    try {
      await api.delete(`/boxes/deleteBox/${selectedBox}`);
      setDeleteModal(false);
      setSelectedBox(null);
      toast.success("Deleted");
      setChanged((prev) => !prev);
    } catch (err) {
      toast.error("Error Occurs");
    }
  };

  const editClickHandler = (id) => {
    setSelectedBox(id);
    setIsEditing(true);
    setOpenModal(true);
  };

  return (
    <>
      {openModal && (
        <Modal
          isLoading={isLoading}
          isEditing={isEditing}
          onSubmit={addNewHandler}
          onClose={() => {
            setOpenModal(false);
            setSelectedBox(null);
            setIsEditing(false);
          }}
          boxId={selectedBox}
        />
      )}
      {deleteModal && (
        <DeleteConfirmationModal
          onClose={() => {
            setDeleteModal(false);
            setSelectedBox(null);
          }}
          onDelete={deleteHandler}
        />
      )}
      <div className={styles.container}>
        <button onClick={() => setOpenModal(true)} className={styles.button}>
          Add New Box
        </button>
        {boxes.length === 0 && (
          <p className={styles.alert}>No Record. Please Add Box to continue</p>
        )}
        {boxes.length > 0 && (
          <DataTable
            className={styles.table}
            columns={columns}
            data={boxes}
            customStyles={customStyles}
            highlightOnHover
          />
        )}
      </div>
    </>
  );
}

export default Boxes;
